import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-fav" })
export class FavInputComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener("click", (event) => this.move(event));
		this.checkCookies();
	}

	private move(event: Event): void {
		const button = event.target as HTMLElement;
		if (button.tagName !== "BUTTON") {
			return;
		}

		const parent = button.parentElement;
		const itemName = button.getAttribute("data-name");

		if (parent && itemName) {
			parent.classList.toggle("fav-active");
			this.updateCookie(
				itemName,
				parent.classList.contains("fav-active")
			);
		}
	}

	private updateCookie(itemName: string, isActive: boolean): void {
		const optionsFav = this.getCookie("OptionsFav");
		let favList = optionsFav ? optionsFav.split(",") : [];

		if (isActive) {
			if (!favList.includes(itemName)) {
				favList.push(itemName);
			}
		} else {
			favList = favList.filter((item) => item !== itemName);
		}

		document.cookie = `OptionsFav=${favList.join(",")}; path=/`;
	}

	private checkCookies(): void {
		const optionsFav = this.getCookie("OptionsFav");
		const favList = optionsFav ? optionsFav.split(",") : [];

		favList.forEach((itemName) => {
			const button = document.querySelector(
				`button[data-name="${itemName}"]`
			);
			if (button) {
				const parent = button.parentElement;
				if (parent) {
					parent.classList.add("fav-active");
				}
			}
		});
	}

	private getCookie(name: string): string | null {
		const cookies = document.cookie.split("; ");
		const cookie = cookies.find((cookie) => cookie.startsWith(`${name}=`));
		return cookie ? cookie.split("=")[1] : null;
	}
}
